export default __webpack_public_path__ + "static/media/ProductSans-Regular.899309ad.svg";